import AccountAPI from '@/apis/other/accountAPI'
import Firebase from '@/commons/firebase'
import { MSConstant } from '@/commons/wildcards'
const url = AccountAPI.getAPIUrl()

export default {
  /**
   * @description Đăng nhập
   * @author NTQuy - 20/12/2022
   * @param {*} param0
   * @param {*} payload
   * @returns
   */
  register: async ({ commit }, payload) => {
    const request = {
      url: `${url}/register`,
      data: payload,
    }
    const showLoading = true
    const res = await AccountAPI.postAsync(request, showLoading)

    return res
  },

  /**
   * @description Đăng ký
   * @author NTQuy - 20/12/2022
   * @param {*} param0
   * @param {*} payload
   * @returns
   */
  login: async ({ commit }, payload) => {
    const request = {
      url: `${url}/login`,
      data: payload,
    }
    const showLoading = true
    const res = await AccountAPI.postAsync(request, showLoading)

    if (res.Succeeded) {
      const data = res.Result
      localStorage.setItem('Token', data.Token)
      commit('updateAccessToken', data.Token)
    }
    return res
  },

  /**
   * @description Quên mật khẩu - veriy số điện thoại
   * @author NTQuy - 20/12/2022
   * @param {*} param0
   * @param {*} payload
   * @returns
   */
  forgotPasswordEnterPhone: async ({ commit }, payload) => {
    const request = {
      url: `${url}/forgot/phone/${payload.UserName}`,
    }

    const showLoading = true
    const res = await AccountAPI.postAsync(request, showLoading)
    return res
  },

  /**
   * @description Quên mật khẩu - veriy email
   * @author NTQuy - 20/12/2022
   * @param {*} param0
   * @param {*} payload
   * @returns
   */
  forgotPasswordEnterEmail: async ({ commit }, payload) => {
    const request = {
      url: `${url}/forgot/email/${payload.UserName}`,
    }

    const showLoading = true
    const res = await AccountAPI.postAsync(request, showLoading)
    return res
  },

  /**
   * @description Quên mật khẩu sử dụng Firebase Authenticate
   * @author PVThang 13.02.2023
   * @param {*} param0
   * @param {*} param1
   * @returns
   */
  forgotPasswordWithFirebase: async ({ commit }, { UserName }) => {
    try {
      commit('updateLoading', true)
      const request = {
        url: `${url}/exist/${UserName}`,
      }
      const showLoading = false
      const validateResult = await AccountAPI.getAsync(request, showLoading)
      if (!validateResult.Succeeded) {
        return validateResult
      }

      const phone = Firebase.formatInternationalPhoneNumber(UserName)
      const confirmationResult = await Firebase.sendOTP(phone)
      return {
        Succeeded: true,
        SessionInfo: confirmationResult.verificationId,
      }
    } catch (error) {
      const authenticateError = MSConstant.AuthenticareError
      const errorCode =
        error.code === Firebase.ErrorCode.PhoneNumberInvalid
          ? authenticateError.InvalidPhoneNumber
          : authenticateError.UndefinedError
      return {
        Errors: [
          {
            Code: errorCode,
          },
        ],
      }
    } finally {
      commit('updateLoading', false)
    }
  },

  /**
   * @description Quên mật khẩu - verify OTP
   * @author NTQuy - 20/12/2022
   * @param {*} param0
   * @param {*} payload
   * @returns
   */
  verifyOTP: async ({ commit }, payload) => {
    const request = {
      url: `${url}/verify-otp/${payload.UserName}/${payload.OTP}`,
      data: {
        sessionInfo: payload.SessionInfo,
      },
    }
    const showLoading = true
    const res = await AccountAPI.postAsync(request, showLoading)
    return res
  },

  /**
   * @description Quên mật khẩu - đổi mật khẩu
   * @author NTQuy - 20/12/2022
   * @param {*} param0
   * @param {*} payload
   * @returns
   */
  resetPassword: async ({ commit }, payload) => {
    const request = {
      url: `${url}/password`,
      data: payload,
    }
    const showLoading = true
    const res = await AccountAPI.putAsync(request, showLoading)
    return res
  },

  /**
   * @description  đổi mật khẩu
   * @author NTQuy - 21/12/2022
   * @param {*} param0
   * @param {*} payload
   * @returns
   */
  changePassword: async ({ commit }, payload) => {
    const request = {
      url: `${url}/change-password`,
      data: payload,
    }
    const showLoading = true
    const res = await AccountAPI.putAsync(request, showLoading)
    return res
  },

  /**
   * @description Kiểm tra tài khoản có tồn tại hay không
   * @author NTQuy - 21/12/2022
   * @param {*} param0
   * @param {*} payload
   * @returns
   */
  existAccount: async ({ commit }, payload) => {
    const request = {
      url: `${url}/exist/${payload}`,
    }
    const showLoading = true
    const res = await AccountAPI.postAsync(request, showLoading)

    return res
  },

  /**
   * xác thực token
   * @param {*} param0
   * @param {*} payload
   * @returns
   */
  getContextData: async ({ commit }) => {
    const request = {
      url: `${url}/context-data`,
    }
    const showLoading = true
    const res = await AccountAPI.getAsync(request, showLoading)
    if (res) {
      commit('updateContext', res)
    } else {
      // Lỗi
    }
    return res
  },

  /**
   * Logout ứng dụng: clear cookie, session server
   * @param {*} context
   * @param {*} payload
   */
  logoutApp: async (context) => {
    const request = {
      url: `${url}/logout`,
    }
    const showLoading = true
    await AccountAPI.postAsync(request, showLoading)

    context.commit('updateLogout')
    // window.location.href = window.__env.logoutUrl
  },

  /**
   * Update thông tin người dùng
   * @param {*} context
   * @param {*} payload
   */
  updateAccountInfor: async ({ commit }, payload) => {
    const request = {
      url: `${url}/update-account-info`,
      data: payload,
    }
    const showLoading = true
    const res = await AccountAPI.postAsync(request, showLoading)
    if (res.Succeeded !== false) {
      commit('updateUser', res)
    }
    return res
  },
}
